<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 점검정보 -->
    <div>
      <h5 class="my-4"><i class="dot"></i>{{ $t("점검정보") }}</h5>
      <div class="writeGridContainer">
        <div>
          <div>{{ $t("공종명") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
          <ml-input v-else v-model="form.inputB_2" readonly />
        </div>
        <div>
          <div>{{ $t("작업내용") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_3 }}</p>
          <ml-input v-else v-model="form.inputB_3" class="w-full flex-1" readonly />
        </div>
        <div />

        <div>
          <div>{{ $t("점검자") }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.점검자 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.점검자" />
        </div>
        <div>
          <div>{{ $t("평가일") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
          <date-selector v-else class="w-full flex-1" v-model="form.inputB_4" :readonly="board.readonly" />
        </div>
        <div />
      </div>
    </div>

    <div>
      <table-inspect-merge
        :is-print="isPrint"
        :is-readonly="board.readonly"
        contentBefore=""
        :title="form.inspectTitle"
        :table-header-title="form.inspectTableHeaderTitle"
        :table-header-note="[{ text: '비고', width: 320 }]"
        v-model="form.inspectList"
        class="mt-5"
        :only-pc="isPrint"
      />

      <table>
        <tbody>
        <tr class="title-tr">
          <td colspan="5" style="border-top: none;" :style="form.etcList.length > 0 ? 'border-bottom: none;': ''">
            <div class="flex justify-between items-center">
              <span>{{ $t("기타 점검항목") }}</span>
              <div class="flex gap-2" v-if="!isPrint">
                <vs-button color="secondary" type="filled" @click="handleAddRow" style="width: 40px; height: 40px; padding: 0; min-height: 40px;">
                  <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                </vs-button>
                <vs-button color="secondary" type="border" @click="handleRemoveRow" style="width: 40px; height: 40px; padding: 0; min-height: 40px;">
                  <feather-icon icon="MinusIcon" svgClasses="h-4 w-4" />
                </vs-button>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <table-inspect-merge
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :contentBefore="isPrint? '·': ''"
        :table-header-note="[{ text: '비고', width: 320 }]"
        v-model="form.etcList"
        :only-pc="isPrint"
        :is-header="false"
      />
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" :isPrint="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="신축현장 점검" class="mt-28px" />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import DateSelector from "@/components/selector/DateSelector";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import CompanySelector from "@/components/selector/CompanySelector";

import inspectData from "./inspectData";
import Pagination from "@/components/Pagination.vue";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";

export default {
  components: {
    PrintCheckbox,
    Pagination,
    FieldSelectModule,
    FileUploadModule,
    TableInspectMerge,
    DateSelector,
    DisasterClassSelector,
    CompanySelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        점검자: "",

        inspectList: [],
        inspectTitle:  this.$t("안전점검표"),
        inspectTableHeaderTitle: "점검항목",
        etcList: [],

        photoList: [],
        fileList: [],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {},
  methods: {

    translationMap() {
      const prefix = "위험성평가.AI 안전점검표";

      const translateData = {
        [`${prefix}.기본정보.회사명`]: this.form.stdInfo.field_name,
        [`${prefix}.기본정보.작성자이름`]: this.form.stdInfo.writer_name,
        [`${prefix}.기본정보.작성일`]: this.form.stdInfo.date,

        [`${prefix}.점검정보.공종명`]: this.form.inputB_2,
        [`${prefix}.점검정보.작업내용`]: this.form.inputB_3,
        [`${prefix}.점검정보.점검자`]: this.form.점검자,
        [`${prefix}.점검정보.평가일`]: this.form.inputB_4,

        [`${prefix}.안전점검표`]: this.form.inspectList.map((item) => {
          console.log("item", item)
          return {
            "제목": item.title,
            "내용": item.content,
            "상태": item.isChecked,
            "비고": item.비고,
          }
        }),

        [`${prefix}.안전점검표.기타`]: this.form.etcList.map((item) => {
          return {
            "점검항목": item.content,
            "상태": item.isChecked,
            "비고": item.비고,
          }
        }),

      };

      return translateData;
    },
    translate(translate) {
      const prefix = "위험성평가.AI 안전점검표";

      this.form.stdInfo.field_name = translate[`${prefix}.기본정보.회사명`];
      this.form.stdInfo.writer_name = translate[`${prefix}.기본정보.작성자이름`];
      this.form.stdInfo.date = translate[`${prefix}.기본정보.작성일`];

      this.form.inputB_2 = translate[`${prefix}.점검정보.공종명`];
      this.form.inputB_3 = translate[`${prefix}.점검정보.작업내용`];
      this.form.점검자 = translate[`${prefix}.점검정보.점검자`];
      this.form.inputB_4 = translate[`${prefix}.점검정보.공종명`];

      const inspectList = translate[`${prefix}.안전점검표`];
      const _inspectList = JSON.parse(JSON.stringify(this.form.inspectList));
      for (let i = 0; i<inspectList.length; i++) {
        _inspectList[i].title = inspectList[i]['제목'];
        _inspectList[i].content = inspectList[i]['내용'];
        _inspectList[i].isChecked = inspectList[i]['상태'];
        _inspectList[i].비고 = inspectList[i]['비고'];
      }
      this.$set(this.form, "inspectList", _inspectList);

      const etcList = translate[`${prefix}.안전점검표.기타`];
      const _etcList = JSON.parse(JSON.stringify(this.form.etcList));
      for (let i = 0; i<etcList.length; i++) {
        _etcList[i].content = etcList[i]['점검항목'];
        _etcList[i].isChecked = etcList[i]['상태'];
        _etcList[i].비고 = etcList[i]['비고'];
      }
      this.$set(this.form, "etcList", _etcList);
    },
    handleAddRow() {
      this.form.etcList.push({
        id: `${Date.now()  }_${  Math.random().toString(36).substr(2, 9)}`,
        content: "",
        isChecked: "",
        note: "",
        content_input: true,
      });
    },

    handleRemoveRow() {
      this.form.etcList.pop();
    },
  },
};
</script>
<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    border: 1px solid #cdcdcd;
  }

  thead {
    th {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      color: #3c3c3c;
      background: #f9f9f9;
      padding: 16px 0;
    }
  }

  tbody {
    .title-tr td {
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;

      background: #f9f9f9;
      padding: 14px;
    }
    .footer-tr td {
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;

      background: #f9f9f9;
    }
    .sub-title {
      text-align: center;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;

      background: #f9f9f9;
      padding: 14px 0;
    }

    .content {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      padding: 14px;

      & > div {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        gap: 8px;
      }

      &.empty-style {
        padding: 4px !important;
        & > div {
          display: block;
        }
      }

      &::v-deep {
        .vs-radio--label {
          line-height: 0;
        }
      }
    }
  }
}
</style>
